/* FLAW 3D — depth, tilt & motion layer (flw-3d.js). Loaded after flw.js; everything degrades to the static theme. */
(function(){
'use strict';
var w=window,d=document,R=d.documentElement;
if(w.__flw3d)return;w.__flw3d=1;
var mq=function(q){return !!(w.matchMedia&&w.matchMedia(q).matches)};
var REDUCE=mq('(prefers-reduced-motion: reduce)');
var FINE=mq('(hover:hover) and (pointer:fine)');
if(REDUCE){R.classList.add('fx-reduce');FINE=false}else{R.classList.add('fx-3d');if(FINE)R.classList.add('fx-fine')}
var DESIGN=R.classList.contains('shopify-design-mode');
var $=function(s,c){return (c||d).querySelector(s)};
var $$=function(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))};
var clamp=function(v,a,b){return v<a?a:v>b?b:v};
var lerp=function(a,b,t){return a+(b-a)*t};
var vh=w.innerHeight,vw=w.innerWidth;

/* ---------- frame loop: tasks return true while they still need frames ---------- */
var tasks=[],queued=false,T={el:null,rect:null,tx:0,ty:0,x:0,y:0,px:.5,py:.5,max:8};
function loop(){queued=false;var more=false;for(var i=0;i<tasks.length;i++){try{if(tasks[i]())more=true}catch(e){}}if(more)kick()}
function kick(){if(!queued){queued=true;requestAnimationFrame(loop)}}
var lastY=w.scrollY,vel=0;
w.addEventListener('scroll',function(){T.rect=null;kick()},{passive:true});
w.addEventListener('resize',function(){vh=w.innerHeight;vw=w.innerWidth;kick()},{passive:true});
function inView(r,m){m=m||0;return r.bottom>-m&&r.top<vh+m&&r.width>0}

/* ---------- 1. Pointer tilt with glare (cards, tiles, social, editorial) ---------- */
var TILT='.flw-card__media,.flw-social__item,.flw-mega__card,.fx-tilt,.flw-tile,.flw-editorial__big,.flw-editorial__pair>a,.flw-spot__visual';
var INNER='.flw-tile,.flw-editorial__big,.flw-editorial__pair>a,.flw-spot__visual';
function tiltTarget(h){return h.matches(INNER)?($('.flw-media',h)||h):h}
function release(el){el.classList.remove('fx-tilting');el.style.removeProperty('--rx');el.style.removeProperty('--ry');el.style.removeProperty('--mx');el.style.removeProperty('--my')}
if(FINE){
  d.addEventListener('pointermove',function(e){
    if(e.pointerType&&e.pointerType!=='mouse')return;
    var h=e.target&&e.target.closest?e.target.closest(TILT):null;
    if(h&&h.closest('.flw-rail.is-drag'))h=null;
    var el=h?tiltTarget(h):null;
    if(el!==T.el){if(T.el)release(T.el);T.el=el;T.rect=null;T.x=0;T.y=0;if(el){el.classList.add('fx-tilting');T.max=el.classList.contains('flw-card__media')?10:(el.closest('.flw-editorial__big,.flw-spot__visual')?5:7)}}
    if(!el)return;
    var r=T.rect||(T.rect=el.getBoundingClientRect());if(!r.width)return;
    T.px=clamp((e.clientX-r.left)/r.width,0,1);T.py=clamp((e.clientY-r.top)/r.height,0,1);
    T.tx=(T.px-.5)*T.max;T.ty=(.5-T.py)*T.max;kick();
  },{passive:true});
  R.addEventListener('mouseleave',function(){if(T.el){release(T.el);T.el=null}});
  w.addEventListener('blur',function(){if(T.el){release(T.el);T.el=null}});
  tasks.push(function(){
    var el=T.el;if(!el)return false;
    T.x=lerp(T.x,T.tx,.16);T.y=lerp(T.y,T.ty,.16);
    var s=el.style;s.setProperty('--ry',T.x.toFixed(2)+'deg');s.setProperty('--rx',T.y.toFixed(2)+'deg');
    s.setProperty('--gx',(T.px*100).toFixed(1)+'%');s.setProperty('--gy',(T.py*100).toFixed(1)+'%');
    s.setProperty('--mx',((T.px-.5)*2).toFixed(3));s.setProperty('--my',((T.py-.5)*2).toFixed(3));
    return Math.abs(T.x-T.tx)>.02||Math.abs(T.y-T.ty)>.02;
  });
}

/* ---------- 2. Heroes: pointer depth + scroll parallax + receding 3D fold ---------- */
var heroes=[];
function initHeroes(scope){
  $$('[data-fx-hero]',scope).forEach(function(sec){
    if(sec.__fx)return;sec.__fx=1;
    var o={sec:sec,fold:$('.flw-hero',sec),media:$$('[data-fx-depth]',sec),float:$$('.flw-hero__cta,.flw-look--hot,.flw-hero__center',sec),x:0,y:0,tx:0,ty:0};
    heroes.push(o);
    if(FINE)sec.addEventListener('pointermove',function(e){o.tx=e.clientX/vw-.5;o.ty=e.clientY/vh-.5;kick()},{passive:true});
    if(FINE)sec.addEventListener('pointerleave',function(){o.tx=0;o.ty=0;kick()},{passive:true});
  });
}
tasks.push(function(){
  var more=false;
  heroes.forEach(function(o){
    var r=o.sec.getBoundingClientRect();if(!inView(r,80))return;
    o.x=lerp(o.x,o.tx,.07);o.y=lerp(o.y,o.ty,.07);
    if(Math.abs(o.x-o.tx)>.001||Math.abs(o.y-o.ty)>.001)more=true;
    var p=clamp(-r.top/Math.max(1,r.height),0,1);
    if(o.fold&&!DESIGN)o.fold.style.setProperty('--hp',p.toFixed(4));
    var mx=(-o.x*22).toFixed(2),my=(p*r.height*.18-o.y*16).toFixed(2);
    o.media.forEach(function(m){m.style.translate=mx+'px '+my+'px'});
    o.float.forEach(function(f,i){var k=f.classList.contains('flw-look--hot')?1.6:1;f.style.translate=(o.x*12*k).toFixed(2)+'px '+(o.y*10*k-p*40).toFixed(2)+'px'});
  });
  return more;
});

/* ---------- 3. Generic scroll depth for [data-fx-depth] outside heroes ---------- */
var depths=[];
function initDepth(scope){
  $$('[data-fx-depth]',scope).forEach(function(el){if(el.__fx||el.closest('[data-fx-hero]'))return;el.__fx=1;depths.push(el)});
}
tasks.push(function(){
  depths.forEach(function(el){
    var r=(el.parentNode||el).getBoundingClientRect();if(!inView(r,100))return;
    var p=((r.top+r.height/2)-vh/2)/vh;el.style.translate='0 '+(-p*r.height*.1).toFixed(2)+'px';
  });
  return false;
});

/* ---------- 4. Story: framed photo follows the pointer in 3D ---------- */
var stories=[];
function initStory(scope){
  $$('.flw-story',scope).forEach(function(st){
    if(st.__fx)return;st.__fx=1;var o={el:st,x:0,y:0,tx:0,ty:0};stories.push(o);
    if(FINE){st.addEventListener('pointermove',function(e){o.tx=e.clientX/vw-.5;o.ty=e.clientY/vh-.5;kick()},{passive:true});st.addEventListener('pointerleave',function(){o.tx=0;o.ty=0;kick()},{passive:true})}
  });
}
tasks.push(function(){
  var more=false;
  stories.forEach(function(o){
    var r=o.el.getBoundingClientRect();if(!inView(r))return;
    o.x=lerp(o.x,o.tx,.08);o.y=lerp(o.y,o.ty,.08);
    if(Math.abs(o.x-o.tx)>.001||Math.abs(o.y-o.ty)>.001)more=true;
    o.el.style.setProperty('--sx',o.x.toFixed(4));o.el.style.setProperty('--sy',o.y.toFixed(4));
  });
  return more;
});

/* ---------- 5. Product rails: subtle 3D coverflow while scrolling ---------- */
var rails=[];
function initRails(scope){
  $$('[data-flw-rail]:not(.flw-social) .flw-rail',scope).forEach(function(rl){
    if(rl.__fx)return;rl.__fx=1;rl.classList.add('fx-cf');rails.push(rl);
    rl.addEventListener('scroll',kick,{passive:true});
  });
}
tasks.push(function(){
  rails.forEach(function(rl){
    if(rl.offsetParent===null)return;
    var rr=rl.getBoundingClientRect();if(!inView(rr,50))return;
    var kids=rl.children,vals=[],sl=rl.scrollLeft,cw=rl.clientWidth/2;
    for(var i=0;i<kids.length;i++){var k=kids[i],base=k.offsetParent===rl?0:rl.offsetLeft;vals.push(clamp((k.offsetLeft-base+k.offsetWidth/2-sl-cw)/Math.max(1,cw),-1.4,1.4))}
    for(var j=0;j<kids.length;j++){var c=vals[j],edge=Math.max(0,Math.abs(c)-.55);
      kids[j].style.setProperty('--cf',(Math.sign(c)*edge*16).toFixed(2)+'deg');
      kids[j].style.setProperty('--cz',(-edge*70).toFixed(1)+'px')}
  });
  return false;
});

/* ---------- 6. Scroll-velocity skew for big marquees ---------- */
var marquees=[];
function initMarquee(scope){$$('.flw-bigmarquee',scope).forEach(function(m){if(m.__fx)return;m.__fx=1;marquees.push(m)})}
tasks.push(function(){
  var y=w.scrollY,dy=y-lastY;lastY=y;vel=lerp(vel,clamp(dy,-60,60),.2);
  var on=Math.abs(vel)>.05;
  marquees.forEach(function(m){m.style.setProperty('--sk',(-vel*.12).toFixed(3)+'deg')});
  if(!on)vel=0;
  return on;
});

/* ---------- 7. 3D entrance for grids, gallery and section heads ---------- */
var io=null;
function initEnter(scope){
  if(!('IntersectionObserver' in w)||DESIGN)return;
  if(!io)io=new IntersectionObserver(function(en){en.forEach(function(e){if(!e.isIntersecting)return;var el=e.target;io.unobserve(el);
    var sib=el.parentNode?Array.prototype.indexOf.call(el.parentNode.children,el):0;el.style.setProperty('--fd',((sib%4)*.07)+'s');
    el.classList.add('fx-in');setTimeout(function(){el.classList.remove('fx-pre','fx-in');el.style.removeProperty('--fd')},1600)})},{rootMargin:'0px 0px -6% 0px',threshold:.04});
  $$('.flw-grid>*:not(.flw-reveal):not(.flw-skel),.flw-head,.flw-pdp__gallery>.flw-pdp__m,.flw-footer__cols>*,.flw-news__grid>*',scope).forEach(function(el){
    if(el.__fxe)return;el.__fxe=1;
    var r=el.getBoundingClientRect();if(r.top<vh*.92)return;
    el.classList.add('fx-pre');io.observe(el);
  });
}

/* ---------- 8. Magnetic buttons ---------- */
if(FINE){
  var mag=null;
  d.addEventListener('pointermove',function(e){
    var b=e.target&&e.target.closest?e.target.closest('[data-fx-magnet]'):null;
    if(mag&&mag!==b){mag.style.translate='';mag=null}
    if(!b)return;mag=b;var r=b.getBoundingClientRect();
    b.style.translate=(((e.clientX-r.left)/r.width-.5)*r.width*.18).toFixed(1)+'px '+(((e.clientY-r.top)/r.height-.5)*r.height*.3).toFixed(1)+'px';
  },{passive:true});
}

/* ---------- 9. Spotlight: 3D coverflow of colourways ---------- */
function initSpot(scope){
  $$('[data-fx-spot]',scope).forEach(function(sec){
    if(sec.__fx)return;sec.__fx=1;
    var st=$('[data-fx-ring]',sec);if(!st)return;
    var ring=$('.flw-spot__ring',st),cards=$$('.flw-spot__card',ring),dots=$$('.flw-spot__dots button',sec),now=$('.flw-spot__now',sec),link=$('[data-spot-link]',sec);
    var n=cards.length;if(!n)return;var i=0,hover=false,seen=false,user=false,dragX=null,dragged=false;
    function set(k){
      i=((k%n)+n)%n;
      cards.forEach(function(c,j){var dd=j-i;if(dd>n/2)dd-=n;if(dd<-n/2)dd+=n;var ad=Math.abs(dd);
        c.style.setProperty('--d',dd);c.style.setProperty('--ad',ad);c.classList.toggle('is-active',dd===0);c.classList.toggle('is-far',ad>1);c.setAttribute('tabindex',dd===0?'0':'-1')});
      dots.forEach(function(b,j){b.classList.toggle('is-active',j===i);b.setAttribute('aria-selected',j===i?'true':'false')});
      var a=cards[i],m=a&&$('.flw-spot__meta b',a);if(now&&m)now.textContent=m.textContent;if(link&&a)link.href=a.getAttribute('href');
      sec.style.setProperty('--spot-c',a&&a.dataset.swatch||'transparent');
    }
    set(0);sec.classList.add('is-ready');
    var prev=$('[data-spot-prev]',sec),next=$('[data-spot-next]',sec);
    prev&&prev.addEventListener('click',function(){user=true;set(i-1)});
    next&&next.addEventListener('click',function(){user=true;set(i+1)});
    dots.forEach(function(b,j){b.addEventListener('click',function(){user=true;set(j)})});
    cards.forEach(function(c,j){c.addEventListener('click',function(e){if(dragged||j!==i){e.preventDefault();if(!dragged){user=true;set(j)}}})});
    st.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){user=true;set(i-1)}else if(e.key==='ArrowRight'){user=true;set(i+1)}});
    st.addEventListener('pointerdown',function(e){dragX=e.clientX;dragged=false});
    w.addEventListener('pointerup',function(e){if(dragX===null)return;var dx=e.clientX-dragX;dragX=null;if(Math.abs(dx)>40){dragged=true;user=true;set(i+(dx<0?1:-1));setTimeout(function(){dragged=false},60)}});
    if(FINE){
      st.addEventListener('pointerenter',function(){hover=true});
      st.addEventListener('pointerleave',function(){hover=false;ring.style.setProperty('--sry','0deg');ring.style.setProperty('--srx','0deg')});
      st.addEventListener('pointermove',function(e){var r=st.getBoundingClientRect();ring.style.setProperty('--sry',(((e.clientX-r.left)/r.width-.5)*14).toFixed(2)+'deg');ring.style.setProperty('--srx',((.5-(e.clientY-r.top)/r.height)*8).toFixed(2)+'deg')},{passive:true});
    }
    if('IntersectionObserver' in w){new IntersectionObserver(function(en){seen=en[0].isIntersecting},{threshold:.35}).observe(st)}else{seen=true}
    if(sec.dataset.autoplay!=='false'&&n>1&&!REDUCE)setInterval(function(){if(seen&&!hover&&!user&&!d.hidden&&!DESIGN)set(i+1)},3800);
  });
}

/* ---------- boot + re-init for dynamic content ---------- */
function init(scope){scope=scope||d;(REDUCE?[initSpot]:[initHeroes,initDepth,initStory,initRails,initMarquee,initEnter,initSpot]).forEach(function(f){try{f(scope)}catch(e){if(w.console)console.warn('flw-3d',e)}});kick()}
function boot(){
  init(d);
  if('MutationObserver' in w){var t=null;new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){if(ms[i].addedNodes.length){clearTimeout(t);t=setTimeout(function(){init(d)},120);return}}}).observe(d.body,{childList:true,subtree:true})}
  d.addEventListener('shopify:section:load',function(e){init(e.target)});
  w.addEventListener('load',kick);
}
w.flwFx=init;
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot);else boot();
})();